var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dv-scroll-board',{key:_vm.refreshFlagKey,style:({width:_vm.width+'px',height:_vm.height+'px'}),attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }